import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ContentloaderModule } from '@signature-it/ngx-generic/components/contentloader';
import { CartOrdersActionsModuleGeneric } from '../../actions/actions.module';
import { ProductImageCartDirectiveModuleGeneric } from '@signature-it/ngx-catalogue/directives';
import { AddToCartModule, quantitySelectorModule } from '@signature-it/ngx-catalogue/components/add-to-cart';
import { OrdersFullLayoutComponentGeneric } from "./full";
import {ProductPipeModule} from '@signature-it/ngx-catalogue/pipes';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        TooltipModule.forRoot(),
        ContentloaderModule,
        ProductImageCartDirectiveModuleGeneric,
        CartOrdersActionsModuleGeneric,
        AddToCartModule,
        quantitySelectorModule,
        ProductPipeModule
    ],
    exports: [
        OrdersFullLayoutComponentGeneric
    ],
    declarations: [
        OrdersFullLayoutComponentGeneric
    ]
})
export class OrdersFullLayoutModuleGeneric {}
